export default __webpack_public_path__ + "static/media/checklist.db8683fd.png";